<template>
    <vue-multiselect
        ref="select"
        v-bind="$attrs"
        :class="stateClass"
        :close-on-select="!multiple"
        :internal-search="internalSearch"
        :label="label"
        :loading="pending"
        :multiple="multiple"
        :options="options"
        :placeholder="$t('Please select')"
        :show-labels="false"
        :track-by="trackBy"
        :value="value"
        autocomplete="off"
        @search-change="handleSearch"
        @input="$emit('input', $event)"
        @open="handleSearch(null)"
    >
        <div v-if="total" slot="beforeList" class="text-center position-sticky" style="top: 0">
            {{ options.length }} / {{ total }}
        </div>

        <div slot="noOptions">
            {{ $t('Type to search') }}
        </div>

        <div slot="noResult">
            {{ $t('No results found') }}
        </div>

        <template
            v-if="!noCustomSlots"
            slot="singleLabel"
            slot-scope="props"
        >
            <div v-html="props.option[label]" />

            <small v-if="props.option.role" v-html="$t(props.option.role)" />

            <ul v-if="props.option.services && props.option.services.length" class="list-unstyled border-top pt-1 mt-1">
                <li
                    v-for="service in props.option.services"
                    :key="service.id"
                >
                    {{ service.external_id }}
                    |
                    {{ service.description }}
                    <template v-if=" service.notice || service.info.notice">
                        |
                        {{ service.notice || service.info.notice }}
                    </template>
                </li>
            </ul>
        </template>

        <template
            v-if="!noCustomSlots"
            slot="option"
            slot-scope="props"
        >
            <div v-html="props.option[label]" />

            <small v-if="props.option.role" v-html="$t(props.option.role)" />

            <ul v-if="props.option.services && props.option.services.length" class="list-unstyled border-top pt-1 mt-1">
                <li
                    v-for="service in props.option.services"
                    :key="service.id"
                >
                    {{ service.external_id }}
                    |
                    {{ service.description }}
                    <template v-if=" service.notice || service.info.notice">
                        |
                        {{ service.notice || service.info.notice }}
                    </template>
                </li>
            </ul>
        </template>
    </vue-multiselect>
</template>

<script>
    import {formStateMixin} from 'bootstrap-vue/src/mixins/form-state';
    import VueMultiselect from 'vue-multiselect/src/Multiselect';

    export default {
        name: 'ResourceSelect',
        components: {VueMultiselect},
        mixins: [formStateMixin],
        props: {
            resource: {
              type: String,
              required: true,
            },
            resourceParams: {
                type: Object,
                default: () => ({}),
            },
            value: {
                type: [Object, Array],
                default: null,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            trackBy: {
                type: String,
                default: 'id'
            },
            label: {
                type: String,
                default: 'name'
            },
            emptyValueLabel: {
                type: String,
                default() {
                    return this.$t('No value')
                }
            },
            eager: {
                type: Boolean,
                default: false
            },
            noCustomSlots: {
                type: Boolean,
                default: false
            },
            withEmptyValue: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                items: [],
                pending: false,
                total: null,
                timeout: null,
                internalSearch: false,
            };
        },
        computed: {
            apiUrl() {
                return `/api/${this.resource}`
            },
            options() {
                let options = this.items;
                if (this.withEmptyValue) {
                    let emptyValue = {};
                    emptyValue[this.trackBy] = '';
                    emptyValue[this.label] = this.emptyValueLabel

                    emptyValue.children = [emptyValue];

                    return [emptyValue].concat(options);
                }
                return options
            }
        },
        mounted() {
            this.$refs.select.$refs.search.autocomplete = 'off';
        },
        created() {
            if (this.eager) {
                this.handleSearch(null)
            }
        },
        methods: {
            handleSearch(search = null) {
                if(this.internalSearch && this.options.length) {
                    return;
                }

                if (this.timeout) {
                    clearTimeout(this.timeout)
                    this.timeout = null;
                }

                this.timeout = setTimeout(() => this.search(search), 300);
            },

            search(search = null) {

                this.pending = true;

                this.axios.get(this.apiUrl, {
                    params: {
                        ...this.resourceParams,
                        search
                    }
                }).then(({data}) => {
                    if (data.data) {
                        this.items = Object.freeze(data.data);
                        this.total = Object.freeze(data.total);
                    } else {
                        this.items = Object.freeze(data);
                        this.internalSearch = true;
                    }
                }).catch(e => {
                    if (!e.response) {
                        throw e;
                    }
                }).finally(() => {
                    this.pending = false;
                })
            }
        },
    };
</script>
